export const TrendCalculator = ({ before, now }) => {
  if (before === 0) {
    return 0;
  }
  return parseInt(((now - before) / before) * 100, 10);
};
